if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        if (!this.form) return;
        
        this.variantIdInput = this.form.querySelector('input[name="id"]');
        this.submitButton = this.form.querySelector('[type="submit"]');
        this.submitText = this.submitButton ? (this.submitButton.querySelector('span') || this.submitButton.querySelector('.product-form__submit-text')) : null;
        
        // Guardar el texto original del botón
        if (this.submitText && !this.submitButton.dataset.originalText) {
          const currentText = this.submitText.textContent.trim();
          if (currentText && currentText !== 'SIN STOCK' && currentText !== 'Sin stock' && currentText !== 'No disponible') {
            this.submitButton.dataset.originalText = currentText;
          }
        }
        
        // Escuchar cambios en el input de variante para actualizar el botón
        if (this.variantIdInput) {
          this.variantIdInput.addEventListener('change', () => this.updateButtonState());
          // También usar MutationObserver para detectar cambios en el atributo value
          const observer = new MutationObserver(() => this.updateButtonState());
          observer.observe(this.variantIdInput, { attributes: true, attributeFilter: ['value'] });
        }
        
        // Actualizar estado inicial del botón
        this.updateButtonState();
        
        // Si tenemos i-minicart y Permalink, interceptar el submit
        const minicart = document.querySelector('i-minicart');
        if (minicart && window.Permalink && window.Permalink.addItems) {
          this.form.addEventListener('submit', this.handleSubmit.bind(this), true);
          
          // También interceptar el click del botón
          if (this.submitButton) {
            this.submitButton.addEventListener('click', (e) => {
              if (this.submitButton.disabled) {
                e.preventDefault();
                e.stopImmediatePropagation();
                return false;
              }
              e.preventDefault();
              e.stopImmediatePropagation();
              this.handleSubmit(e);
            }, true);
          }
          
          // Prevenir el comportamiento por defecto del formulario
          this.form.setAttribute('onsubmit', 'return false;');
          this.form.action = 'javascript:void(0);';
        } else {
          // Comportamiento por defecto de Shopify si no hay minicart
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        }
      }

      handleSubmit(evt) {
        if (evt) {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          evt.stopPropagation();
        }

        if (!this.variantIdInput || !window.Permalink || !window.Permalink.addItems) {
          console.error('ProductForm: Missing variant ID or Permalink.addItems');
          return false;
        }

        const variantId = parseInt(this.variantIdInput.value);
        if (!variantId) {
          console.error('ProductForm: Invalid variant ID');
          return false;
        }

        // Obtener la cantidad
        const quantityInput = this.form.querySelector('input[name="quantity"]');
        const quantity = quantityInput ? parseInt(quantityInput.value || '1', 10) : 1;

        // Deshabilitar el botón mientras se añade
        if (this.submitButton) {
          this.submitButton.disabled = true;
          const spinner = this.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
          this.submitButton.classList.add('loading');
        }

        // Añadir al carrito usando Permalink.addItems
        window.Permalink.addItems([{
          id: variantId,
          quantity: quantity
        }], true).then(() => {
          // Restaurar el botón
          if (this.submitButton) {
            this.submitButton.disabled = false;
            this.submitButton.classList.remove('loading');
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          }
        }).catch((error) => {
          console.error('ProductForm: Error adding to cart:', error);
          // Restaurar el botón
          if (this.submitButton) {
            this.submitButton.disabled = false;
            this.submitButton.classList.remove('loading');
            const spinner = this.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');
          }
        });

        return false;
      }

      onSubmitHandler(evt) {
        // Comportamiento por defecto de Shopify (solo si no hay minicart)
        evt.preventDefault();
        // Aquí iría la lógica por defecto de Shopify si fuera necesaria
      }
    }
  );
}

